/**
 *
 */
var TouchPoint = /** @class */ (function () {
    function TouchPoint(x, y, id) {
        this.x = x;
        this.y = y;
        this.id = id;
    }
    return TouchPoint;
}());
export { TouchPoint };
